import {
  SaleRepCreateBody,
  SaleRepListResponse,
  SaleRepItem,
  SaleRepDetailResponse,
} from "utils/api/client/types"

export class SaleRep {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    vendorId: string,
    body: SaleRepCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<{ data: SaleRepItem }> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sales-reps`,
        {
          method: "POST",
          headers,
          body,
          query,
        }
      )
    })()
  }

  update(
    id: string,
    vendorId: string,
    body: SaleRepCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SaleRepItem> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sales-reps/${id}`,
        {
          method: "PUT",
          headers,
          body,
          query,
        }
      )
    })()
  }

  list(
    vendorId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SaleRepListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sales-reps`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  retrieve(
    id: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<SaleRepDetailResponse> {
    return (async () => {
      const { vendorId, ...reset } = queryParams as any
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sales-reps/${id}`,
        {
          query: reset,
          headers,
        }
      )
    })()
  }

  delete(
    id: string | number,
    vendorId: string,
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sales-reps/${id}`,
        {
          method: "DELETE",
          headers,
        }
      )
    })()
  }

  resetPassword(
    id: string,
    vendorId: string,
    body?: { newPassword: string },
    headers?: Record<string, unknown>
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/vendor/${vendorId}/sales-reps/${id}/reset-password`,
        {
          method: "POST",
          headers,
          body,
        }
      )
    })()
  }
}
